module.exports = __webpack_public_path__ + "static/schdule-bg.7139fd4d.png";